import { render, staticRenderFns } from "./VipDay.vue?vue&type=template&id=a73f55a6&scoped=true&"
import script from "./VipDay.vue?vue&type=script&lang=js&"
export * from "./VipDay.vue?vue&type=script&lang=js&"
import style0 from "./VipDay.vue?vue&type=style&index=0&id=a73f55a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73f55a6",
  null
  
)

export default component.exports